<template>
	<div id="app">
		<Header v-if="hasHeader"></Header>
		<section class="section">
			<router-view />
		</section>
	</div>
</template>
<script>
	import Header from '@/components/header.vue';
	import Header2 from '@/components/header2.vue';
	export default {
		name: '',
		components: {
			Header,
			Header2
		},
		data() {
			return {
				hasHeader:true,
			}
		},
		watch: {
		    '$route'(to, from) {
				// 路由变化时的处理逻辑
				if(to.path=='/mapFull'){
					this.hasHeader=false;
				}else{
					this.hasHeader=true;
				}
		    }
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>
<style>
	.section{
		height: calc( 100vh - 74px );
	}
</style>